// These are the only locales that we officially support right now (NOTE: all CA yards currently use the US locale)
// If we need to add more locales, the full list of dayjs locales is here: https://github.com/iamkun/dayjs/tree/dev/src/locale
// Any new locales need to be added to DAY_JS_LOCALE_IMPORTS and also to the LOCALE_MAP in constants.tsx
const DAY_JS_LOCALE_IMPORTS = {
  en: () => import('dayjs/locale/en'),
  'en-nz': () => import('dayjs/locale/en-nz'),
}

const importLocaleForDayjs = (dayjsLocale = 'en') => {
  if (DAY_JS_LOCALE_IMPORTS[dayjsLocale]) {
    DAY_JS_LOCALE_IMPORTS[dayjsLocale]()
  }
}

export default importLocaleForDayjs
